module.exports = __webpack_public_path__ + "img/s3.24b07846.jpg";